import { ICheckboxGroup } from "@into-discovery/browsewebshared";

// Helper function to convert a string to sentence case
const toSentenceCase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const useFacets = (facets: ICheckboxGroup[]): ICheckboxGroup[] => {
  // Deep copy of the facets array
  const result = facets.map((f) => ({ ...f }));

  // Check if it has "Country" and get the country option
  const countryObj = result.find((item) => item.name === "Country" && item.options.length === 1);
  const countryOption = countryObj ? countryObj.options[0].name : null;

  // Modify "Program Group" based on the country option
  if (countryOption) {
    result.forEach((item) => {
      if (item.name === "Program Group") {
        item.name = countryOption === "UK" ? "Programmes group" : countryOption === "US" ? "Degrees group" : item.name;
      }
    });
  }

  // Remove "Country" and "University" objects and convert parent level name fields to sentence case
  const filteredResult = result
    .filter((item) => item.name !== "Country" && item.name !== "University")
    .map((item) => ({
      ...item,
      name: toSentenceCase(item.name)
    }));

  return filteredResult;
};
